"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  HumanResourcesRatingMan: ['human-resources-rating-man', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.566,1.017a.486.486,0,0,1,.868,0l1.009,2.034a.483.483,0,0,0,.363.262l2.264.327a.481.481,0,0,1,.389.323.47.47,0,0,1-.121.487L14.7,6.044a.473.473,0,0,0-.138.419l.388,2.247a.474.474,0,0,1-.194.465.487.487,0,0,1-.509.035L12.226,8.156a.482.482,0,0,0-.452,0L9.758,9.21a.487.487,0,0,1-.509-.035.474.474,0,0,1-.194-.465l.388-2.247a.473.473,0,0,0-.138-.419L7.662,4.45a.47.47,0,0,1-.121-.487A.481.481,0,0,1,7.93,3.64l2.264-.327a.483.483,0,0,0,.363-.262Z', 'M6.322,10.1,5.459,9.65a.49.49,0,0,0-.453,0L2.991,10.7a.491.491,0,0,1-.51-.034.474.474,0,0,1-.193-.466l.387-2.246a.471.471,0,0,0-.137-.419L.894,5.944a.472.472,0,0,1-.12-.487.481.481,0,0,1,.389-.323l2.263-.327a.483.483,0,0,0,.364-.262L4.8,2.511a.484.484,0,0,1,.434-.267', 'M17.678,10.1l.863-.451a.49.49,0,0,1,.453,0L21.009,10.7a.491.491,0,0,0,.51-.034.474.474,0,0,0,.193-.466l-.387-2.246a.471.471,0,0,1,.137-.419l1.644-1.595a.472.472,0,0,0,.12-.487.481.481,0,0,0-.389-.323l-2.263-.327a.483.483,0,0,1-.364-.262L19.2,2.511a.484.484,0,0,0-.434-.267', 'M17.029,23.245a6.679,6.679,0,0,0-10.06,0', 'M8.445,13.242a6.858,6.858,0,0,0,7.643,1.536', 'M7.875 15.336 A4.125 4.125 0 1 0 16.125 15.336 A4.125 4.125 0 1 0 7.875 15.336 Z']],
  HumanResourcesEmployeePrevious1: ['human-resources-employee-previous-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M13.5,21.75A9.75,9.75,0,1,0,3.75,12v.75', 'M0.75 9.75L3.75 12.75 6.75 9.75', 'M18.334,16.5c-.783-.336-1.729-.676-2.778-1.065-.652-.241-.545-1.943-.256-2.261a4.813,4.813,0,0,0,1.252-3.73A3.144,3.144,0,0,0,13.5,6a3.144,3.144,0,0,0-3.052,3.444,4.813,4.813,0,0,0,1.252,3.73c.289.318.4,2.02-.256,2.261-1.049.389-2,.729-2.778,1.065']],
  HumanResourcesBusinessmanMail: ['human-resources-businessman-mail', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M16.500 3.750 A3.000 3.000 0 1 0 22.500 3.750 A3.000 3.000 0 1 0 16.500 3.750 Z', 'M23.212,9.787A5.25,5.25,0,0,0,14.25,13.5v2.25H16.5l.75,7.5h4.5l.75-7.5h.75', 'M19.5 8.25L19.5 12.75', 'M0.750 0.750 L12.750 0.750 L12.750 9.750 L0.750 9.750 Z', 'M0.75 3L6.75 6 12.75 3']],
  HumanResourcesOfferEmployee1: ['human-resources-offer-employee-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.754 14.242L0.754 23.242', 'M.754,21.742h15a3,3,0,0,0-3-3H9a3,3,0,0,0-3-3H.754', 'M6.004 18.742L9.004 18.742', 'M10.727,13.756A6.751,6.751,0,0,1,23.254,17.25H16.5', 'M12.379 4.875 A4.125 4.125 0 1 0 20.629 4.875 A4.125 4.125 0 1 0 12.379 4.875 Z']],
  HumanResourcesEmployeeStress: ['human-resources-employee-stress', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M15.296 18.458L11.25 23.25', 'M20.259,23.256C19.331,19.849,16.054,18,12.018,18s-7.3,1.852-8.225,5.261', 'M3 1.866L1.5 0.75', 'M3 7.5L1.5 8.25', 'M2.808 4.5L0.75 4.5', 'M21 1.866L22.5 0.75', 'M21 7.5L22.5 8.25', 'M21.192 4.5L23.25 4.5', 'M6,8.25V.75L9,3,12,.75,15,3,18,.75v7.5A24.375,24.375,0,0,1,6,8.25Z', 'M18,8.25v1.5a6,6,0,0,1-6,6h0a6,6,0,0,1-6-6V8.25']],
  HumanResourcesEmployeeStar: ['human-resources-employee-star', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M22.5,23.25v-.927a2.023,2.023,0,0,0-.788-1.615C20.347,19.666,17.823,18,11.962,18s-8.385,1.666-9.75,2.708a2.022,2.022,0,0,0-.787,1.615v.927', 'M14.008 23.25L11.962 18 9.917 23.25', 'M19.462 23.25L17.212 23.25', 'M12.858,1.288l1.926,5.09h3.75a.919.919,0,0,1,.648,1.6l-3.255,2.266,1.8,4.141a.982.982,0,0,1-1.4,1.228l-4.358-2.451L7.615,15.617a.982.982,0,0,1-1.4-1.228l1.8-4.141L4.765,7.982a.918.918,0,0,1,.644-1.6h3.75l1.931-5.09A1,1,0,0,1,12.858,1.288Z']],
  HumanResourcesOfferEmployee: ['human-resources-offer-employee', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.749 14.25L0.749 23.25', 'M.749,21.75h15a3,3,0,0,0-3-3H9a3,3,0,0,0-3-3H.749', 'M5.999 18.75L8.999 18.75', 'M23.238,13.757c-.567-.975-2.635-1.668-5.227-2.628-.717-.266-.6-2.138-.282-2.488a5.292,5.292,0,0,0,1.377-4.1C19.106,2.2,17.578.75,15.749.75S12.392,2.2,12.392,4.538a5.292,5.292,0,0,0,1.377,4.1c.318.35.435,2.222-.282,2.488C11.128,12,9.2,12.655,8.449,13.5']],
  HumanResourcesSearchTeam: ['human-resources-search-team', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M4.7,8.78a6.851,6.851,0,0,0,7.642,1.536', 'M4.124 10.875 A4.125 4.125 0 1 0 12.374 10.875 A4.125 4.125 0 1 0 4.124 10.875 Z', 'M0.749 12.000 A11.250 11.250 0 1 0 23.249 12.000 A11.250 11.250 0 1 0 0.749 12.000 Z', 'M14.987,22.848A6.749,6.749,0,0,0,3.1,18.884', 'M14.999 13.125 A2.625 2.625 0 1 0 20.249 13.125 A2.625 2.625 0 1 0 14.999 13.125 Z', 'M21.274,18.368a4.5,4.5,0,0,0-7.719.709']],
  HumanResourcesSearchEmployees: ['human-resources-search-employees', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M.749,23.25A7.9,7.9,0,0,1,1.4,20.135c.47-.919,2.431-1.557,4.893-2.45.666-.241.557-1.943.262-2.261a4.753,4.753,0,0,1-1.279-3.73A3.2,3.2,0,0,1,8.019,8.272', 'M11.4,13.1a4.187,4.187,0,0,1-1.169,2.323c-.295.318-.405,2.02.262,2.261,2.462.893,4.423,1.531,4.893,2.45a8.033,8.033,0,0,1,.666,3.115', 'M19.367,23.25h2.368v-.817c0-2.894-2-3.361-4.007-4.1-.665-.247-.556-1.984-.262-2.308a4.349,4.349,0,0,0,1.2-2.551', 'M10.499 6.014 A5.250 5.250 0 1 0 20.999 6.014 A5.250 5.250 0 1 0 10.499 6.014 Z', 'M23.249 13.514L19.461 9.726']],
  HumanResourcesSearchMen: ['human-resources-search-men', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M10.129 6.000 A5.250 5.250 0 1 0 20.629 6.000 A5.250 5.250 0 1 0 10.129 6.000 Z', 'M22.879 13.5L19.091 9.712', 'M11.647,13.125A4.125,4.125,0,1,1,7.522,9', 'M13.888,23.25a6.752,6.752,0,0,0-12.731,0', 'M19.8,14.723A3.474,3.474,0,0,1,13.887,17.2', 'M21.689,23.25a5.686,5.686,0,0,0-9.19-2.307']],
  HumanResourcesOfferMan: ['human-resources-offer-man', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.749 14.25L0.749 23.25', 'M.749,21.75h15a3,3,0,0,0-3-3H9a3,3,0,0,0-3-3H.749', 'M5.999 18.75L8.999 18.75', 'M12.740 4.875 A4.125 4.125 0 1 0 20.990 4.875 A4.125 4.125 0 1 0 12.740 4.875 Z', 'M23.23,15A6.752,6.752,0,0,0,10.5,15']],
  HumanResourcesHierarchyWoman: ['human-resources-hierarchy-woman', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M14.249,20.25h-1a.51.51,0,0,1-.5-.519V3.518a.509.509,0,0,1,.5-.518h1', 'M17.249 3.000 A2.250 2.250 0 1 0 21.749 3.000 A2.250 2.250 0 1 0 17.249 3.000 Z', 'M23.249,9A4.047,4.047,0,0,0,19.5,6a4.047,4.047,0,0,0-3.75,3Z', 'M17.249 17.250 A2.250 2.250 0 1 0 21.749 17.250 A2.250 2.250 0 1 0 17.249 17.250 Z', 'M23.249,23.25a4.047,4.047,0,0,0-3.75-3,4.047,4.047,0,0,0-3.75,3Z', 'M.749,18a4.5,4.5,0,0,1,9,0Z', 'M8.454,9.235V10a4.506,4.506,0,0,0,.657,2.5', 'M2.155,9.235V10A4.515,4.515,0,0,1,1.5,12.5', 'M2.164,9.4A4.19,4.19,0,0,0,5.305,7.951,4.187,4.187,0,0,0,8.445,9.4', 'M2.154 9.150 A3.151 3.151 0 1 0 8.456 9.150 A3.151 3.151 0 1 0 2.154 9.150 Z', 'M12.749 11.25L11.249 11.25']],
  HumanResourcesWorkflow: ['human-resources-workflow', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9.749 9.750 A2.250 2.250 0 1 0 14.249 9.750 A2.250 2.250 0 1 0 9.749 9.750 Z', 'M15.749,15.75a4.047,4.047,0,0,0-3.75-3,4.047,4.047,0,0,0-3.75,3', 'M10.124 2.625 A1.875 1.875 0 1 0 13.874 2.625 A1.875 1.875 0 1 0 10.124 2.625 Z', 'M19.499 12.000 A1.875 1.875 0 1 0 23.249 12.000 A1.875 1.875 0 1 0 19.499 12.000 Z', 'M10.124 21.375 A1.875 1.875 0 1 0 13.874 21.375 A1.875 1.875 0 1 0 10.124 21.375 Z', 'M0.749 12.000 A1.875 1.875 0 1 0 4.499 12.000 A1.875 1.875 0 1 0 0.749 12.000 Z', 'M16.5,4.2a9.041,9.041,0,0,1,3.3,3.3', 'M19.8,16.5a9.041,9.041,0,0,1-3.3,3.3', 'M7.5,19.8a9.041,9.041,0,0,1-3.3-3.3', 'M4.2,7.5A9.041,9.041,0,0,1,7.5,4.2']],
  HumanResourcesEmployee: ['human-resources-employee', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.566,1.017a.486.486,0,0,1,.868,0l1.009,2.034a.483.483,0,0,0,.363.262l2.264.327a.481.481,0,0,1,.389.323.47.47,0,0,1-.121.487L14.7,6.044a.473.473,0,0,0-.138.419l.388,2.247a.474.474,0,0,1-.194.465.487.487,0,0,1-.509.035L12.226,8.156a.482.482,0,0,0-.452,0L9.758,9.21a.487.487,0,0,1-.509-.035.474.474,0,0,1-.194-.465l.388-2.247a.473.473,0,0,0-.138-.419L7.662,4.45a.47.47,0,0,1-.121-.487A.481.481,0,0,1,7.93,3.64l2.264-.327a.483.483,0,0,0,.363-.262Z', 'M6.322,10.1,5.459,9.65a.49.49,0,0,0-.453,0L2.991,10.7a.491.491,0,0,1-.51-.034.474.474,0,0,1-.193-.466l.387-2.246a.471.471,0,0,0-.137-.419L.894,5.944a.472.472,0,0,1-.12-.487.481.481,0,0,1,.389-.323l2.263-.327a.483.483,0,0,0,.364-.262L4.8,2.511a.484.484,0,0,1,.434-.267', 'M17.678,10.1l.863-.451a.49.49,0,0,1,.453,0L21.009,10.7a.491.491,0,0,0,.51-.034.474.474,0,0,0,.193-.466l-.387-2.246a.471.471,0,0,1,.137-.419l1.644-1.595a.472.472,0,0,0,.12-.487.481.481,0,0,0-.389-.323l-2.263-.327a.483.483,0,0,1-.364-.262L19.2,2.511a.484.484,0,0,0-.434-.267', 'M17.027,23.243a6.678,6.678,0,0,0-10.052,0', 'M7.875 15.336 A4.125 4.125 0 1 0 16.125 15.336 A4.125 4.125 0 1 0 7.875 15.336 Z']],
  HumanResourcesTeamSettings: ['human-resources-team-settings', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M1.879 17.625 A2.625 2.625 0 1 0 7.129 17.625 A2.625 2.625 0 1 0 1.879 17.625 Z', 'M8.254,23.25a4.25,4.25,0,0,0-7.5,0', 'M16.879 17.625 A2.625 2.625 0 1 0 22.129 17.625 A2.625 2.625 0 1 0 16.879 17.625 Z', 'M23.254,23.25a4.25,4.25,0,0,0-7.5,0', 'M9.379 3.375 A2.625 2.625 0 1 0 14.629 3.375 A2.625 2.625 0 1 0 9.379 3.375 Z', 'M15.253,8.25a4.269,4.269,0,0,0-6.5,0', 'M9.055,19.707A8.28,8.28,0,0,0,15,19.689', 'M6.353,6a8.216,8.216,0,0,0-2.6,6c0,.253.015.5.038.75', 'M20.216,12.75c.023-.248.038-.5.038-.75a8.216,8.216,0,0,0-2.6-6', 'M9.754 13.500 A2.250 2.250 0 1 0 14.254 13.500 A2.250 2.250 0 1 0 9.754 13.500 Z', 'M14.254 13.5L15.754 13.5', 'M8.254 13.5L9.754 13.5', 'M12.004 15.75L12.004 17.25', 'M12.004 9.75L12.004 11.25', 'M13.595 15.091L14.656 16.151', 'M9.352 10.848L10.413 11.909', 'M10.413 15.091L9.352 16.151', 'M14.656 10.848L13.595 11.909']],
  HumanResourcesWomanPrevious: ['human-resources-woman-previous', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M13.5,21.75A9.75,9.75,0,1,0,3.75,12v.75', 'M0.75 9.75L3.75 12.75 6.75 9.75', 'M9.377,9.486v1a5.9,5.9,0,0,1-.86,3.272', 'M17.624,9.486v1a5.9,5.9,0,0,0,.859,3.272', 'M9.388,9.7a5.483,5.483,0,0,0,4.112-1.9,5.483,5.483,0,0,0,4.112,1.9', 'M9.375 9.375 A4.125 4.125 0 1 0 17.625 9.375 A4.125 4.125 0 1 0 9.375 9.375 Z', 'M18.42,17.139a6.783,6.783,0,0,0-2.413-1.646L13.5,18l-2.507-2.507A6.792,6.792,0,0,0,8.215,17.56']],
  HumanResourcesOfferMan1: ['human-resources-offer-man-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.749 14.25L0.749 23.25', 'M.749,21.75h15a3,3,0,0,0-3-3H9a3,3,0,0,0-3-3H.749', 'M5.999 18.75L8.999 18.75', 'M10.722,13.763a6.751,6.751,0,0,1,12.527,3.494H16.5', 'M12.944,2.788a6.848,6.848,0,0,0,4.93,2.094,6.851,6.851,0,0,0,2.713-.558', 'M12.374 4.882 A4.125 4.125 0 1 0 20.624 4.882 A4.125 4.125 0 1 0 12.374 4.882 Z', 'M16.499 10.507L16.499 13.507']],
  HumanResourcesEmployeePrevious: ['human-resources-employee-previous', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M13.5,21.75A9.75,9.75,0,1,0,3.75,12v.75', 'M0.75 9.75L3.75 12.75 6.75 9.75', 'M18.48,17.25a6.636,6.636,0,0,0-9.96,0', 'M9.750 10.500 A3.750 3.750 0 1 0 17.250 10.500 A3.750 3.750 0 1 0 9.750 10.500 Z']],
  HumanResourcesBusinessmanClock: ['human-resources-businessman-clock', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M15.000 3.750 A3.000 3.000 0 1 0 21.000 3.750 A3.000 3.000 0 1 0 15.000 3.750 Z', 'M12.75,14.25v1.5H15l.75,7.5h4.5l.75-7.5h2.25V13.5a5.253,5.253,0,0,0-7.5-4.745', 'M18 8.25L18 12.75', 'M0.750 6.750 A6.000 6.000 0 1 0 12.750 6.750 A6.000 6.000 0 1 0 0.750 6.750 Z', 'M9.321 6.75L6.75 6.75 6.75 4.178']],
  HumanResourcesBusinessman: ['human-resources-businessman', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M2.250 3.750 A3.000 3.000 0 1 0 8.250 3.750 A3.000 3.000 0 1 0 2.250 3.750 Z', 'M5.25 8.25L5.25 14.25', 'M9.689,12.01a4.5,4.5,0,0,0-8.939.74v3h1.5L3,23.25H7.5l.75-7.5', 'M11.250 14.250 L23.250 14.250 L23.250 23.250 L11.250 23.250 Z', 'M11.25 18L23.25 18', 'M17.25 17.25L17.25 19.5', 'M15,14.25V13.5a2.25,2.25,0,0,1,2.25-2.25h0A2.25,2.25,0,0,1,19.5,13.5v.75']],
  HumanResourcesHierarchy: ['human-resources-hierarchy', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.749,18.75V14.727a.477.477,0,0,1,.477-.477H19.772a.477.477,0,0,1,.477.477V18.75', 'M11.999 11.25L11.999 18.75', 'M1.499 21.000 A2.250 2.250 0 1 0 5.999 21.000 A2.250 2.250 0 1 0 1.499 21.000 Z', 'M9.749 21.000 A2.250 2.250 0 1 0 14.249 21.000 A2.250 2.250 0 1 0 9.749 21.000 Z', 'M17.999 21.000 A2.250 2.250 0 1 0 22.499 21.000 A2.250 2.250 0 1 0 17.999 21.000 Z', 'M8.999 3.750 A3.000 3.000 0 1 0 14.999 3.750 A3.000 3.000 0 1 0 8.999 3.750 Z', 'M16.5,11.25A4.966,4.966,0,0,0,11.923,7.5a4.966,4.966,0,0,0-4.577,3.75']],
  HumanResourcesManPrevious: ['human-resources-man-previous', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M13.5,21.75A9.75,9.75,0,1,0,3.75,12v.75', 'M0.75 9.75L3.75 12.75 6.75 9.75', 'M18.48,17.25a6.636,6.636,0,0,0-9.96,0', 'M9.945,7.281a6.858,6.858,0,0,0,7.643,1.536', 'M9.375 9.375 A4.125 4.125 0 1 0 17.625 9.375 A4.125 4.125 0 1 0 9.375 9.375 Z', 'M13.5 15L13.5 18']],
  HumanResourcesHierarchy1: ['human-resources-hierarchy-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M14.249,20.25h-1a.51.51,0,0,1-.5-.519V3.518a.509.509,0,0,1,.5-.518h1', 'M10.499 12L12.749 12', 'M17.249 3.000 A2.250 2.250 0 1 0 21.749 3.000 A2.250 2.250 0 1 0 17.249 3.000 Z', 'M23.249,9A4.047,4.047,0,0,0,19.5,6a4.047,4.047,0,0,0-3.75,3Z', 'M17.249 17.250 A2.250 2.250 0 1 0 21.749 17.250 A2.250 2.250 0 1 0 17.249 17.250 Z', 'M23.249,23.25a4.047,4.047,0,0,0-3.75-3,4.047,4.047,0,0,0-3.75,3Z', 'M2.249 9.000 A3.000 3.000 0 1 0 8.249 9.000 A3.000 3.000 0 1 0 2.249 9.000 Z', 'M.749,18a4.5,4.5,0,0,1,9,0Z']],
  HumanResourcesNetwork: ['human-resources-network', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.25,23.25a6.73,6.73,0,0,0-6.337-4.5h-.006a6.729,6.729,0,0,0-6.336,4.5', 'M13.353,11.031A6.857,6.857,0,0,0,21,12.567', 'M12.782 13.125 A4.125 4.125 0 1 0 21.032 13.125 A4.125 4.125 0 1 0 12.782 13.125 Z', 'M16.778 18.75L16.778 23.25', 'M5.737,21.347A11.251,11.251,0,1,1,22.756,8.693q.073.24.137.483', 'M7.981,19.4A26.115,26.115,0,0,1,7.076,7.565,16.281,16.281,0,0,1,9.289,1.078', 'M0.775 11.25L9.75 11.25', 'M2.482 6L21.518 6', 'M1.686 16.5L9.75 16.5', 'M14.711,1.078A14.453,14.453,0,0,1,16.634,6']],
  HumanResourcesRatingWoman: ['human-resources-rating-woman', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.566,1.017a.486.486,0,0,1,.868,0l1.009,2.034a.483.483,0,0,0,.363.262l2.264.327a.481.481,0,0,1,.389.323.47.47,0,0,1-.121.487L14.7,6.044a.473.473,0,0,0-.138.419l.388,2.247a.474.474,0,0,1-.194.465.487.487,0,0,1-.509.035L12.226,8.156a.482.482,0,0,0-.452,0L9.758,9.21a.487.487,0,0,1-.509-.035.474.474,0,0,1-.194-.465l.388-2.247a.473.473,0,0,0-.138-.419L7.662,4.45a.47.47,0,0,1-.121-.487A.481.481,0,0,1,7.93,3.64l2.264-.327a.483.483,0,0,0,.363-.262Z', 'M6.322,10.1,5.459,9.65a.49.49,0,0,0-.453,0L2.991,10.7a.491.491,0,0,1-.51-.034.474.474,0,0,1-.193-.466l.387-2.246a.471.471,0,0,0-.137-.419L.894,5.944a.472.472,0,0,1-.12-.487.481.481,0,0,1,.389-.323l2.263-.327a.483.483,0,0,0,.364-.262L4.8,2.511a.484.484,0,0,1,.434-.267', 'M17.678,10.1l.863-.451a.49.49,0,0,1,.453,0L21.009,10.7a.491.491,0,0,0,.51-.034.474.474,0,0,0,.193-.466l-.387-2.246a.471.471,0,0,1,.137-.419l1.644-1.595a.472.472,0,0,0,.12-.487.481.481,0,0,0-.389-.323l-2.263-.327a.483.483,0,0,1-.364-.262L19.2,2.511a.484.484,0,0,0-.434-.267', 'M7.877,15.447v1a5.905,5.905,0,0,1-.86,3.272', 'M16.124,15.447v1a5.906,5.906,0,0,0,.859,3.272', 'M7.888,15.665A5.483,5.483,0,0,0,12,13.766a5.483,5.483,0,0,0,4.112,1.9', 'M7.875 15.336 A4.125 4.125 0 1 0 16.125 15.336 A4.125 4.125 0 1 0 7.875 15.336 Z', 'M17.047,23.25a6.77,6.77,0,0,0-2.54-1.8L12,23.211,9.493,21.454a6.774,6.774,0,0,0-2.53,1.784']],
  HumanResourcesOfferWoman1: ['human-resources-offer-woman-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.749 14.25L0.749 23.25', 'M.749,21.75h15a3,3,0,0,0-3-3H9a3,3,0,0,0-3-3H.749', 'M5.999 18.75L8.999 18.75', 'M12.376,4.986v1a5.9,5.9,0,0,1-.86,3.272', 'M20.623,4.986v1a5.9,5.9,0,0,0,.859,3.272', 'M12.387,5.2a5.483,5.483,0,0,0,4.112-1.9,5.483,5.483,0,0,0,4.112,1.9', 'M12.374 4.875 A4.125 4.125 0 1 0 20.624 4.875 A4.125 4.125 0 1 0 12.374 4.875 Z', 'M17.249,17.25h6a6.742,6.742,0,0,0-4.243-6.257L16.5,13.5l-2.507-2.507a6.783,6.783,0,0,0-3.374,2.949']],
  HumanResourcesHierarchyMan: ['human-resources-hierarchy-man', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M14.249,20.25h-1a.51.51,0,0,1-.5-.519V3.518a.509.509,0,0,1,.5-.518h1', 'M10.499 12L12.749 12', 'M17.249 3.000 A2.250 2.250 0 1 0 21.749 3.000 A2.250 2.250 0 1 0 17.249 3.000 Z', 'M23.249,9A4.047,4.047,0,0,0,19.5,6a4.047,4.047,0,0,0-3.75,3Z', 'M17.249 17.250 A2.250 2.250 0 1 0 21.749 17.250 A2.250 2.250 0 1 0 17.249 17.250 Z', 'M23.249,23.25a4.047,4.047,0,0,0-3.75-3,4.047,4.047,0,0,0-3.75,3Z', 'M2.72,7.477A4.986,4.986,0,0,0,8.278,8.594', 'M2.305 9.000 A3.000 3.000 0 1 0 8.305 9.000 A3.000 3.000 0 1 0 2.305 9.000 Z', 'M.805,18a4.5,4.5,0,0,1,9,0Z']],
  HumanResourcesSearchWomen: ['human-resources-search-women', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M10.115 6.000 A5.250 5.250 0 1 0 20.615 6.000 A5.250 5.250 0 1 0 10.115 6.000 Z', 'M22.865 13.5L19.077 9.712', 'M6.8,7.635C4.775,8.4,3,10.261,2.76,13.769c-.22,3.255-.8,3.782-1.636,4.62a8.059,8.059,0,0,0,5.581,1.472', 'M11.636,19.87a8.123,8.123,0,0,0,5.581-1.481c-.839-.838-1.416-1.365-1.637-4.62', 'M16.144,23.158c-1.114-.461-2.432-.932-3.864-1.462a.986.986,0,0,1-.644-.925v-1.8a.985.985,0,0,1,.32-.727A3.552,3.552,0,0,0,13.115,15.6V13.13A6.405,6.405,0,0,1,9.17,10.9,6.4,6.4,0,0,1,5.226,13.13V15.6a3.55,3.55,0,0,0,1.159,2.648.987.987,0,0,1,.32.728v1.8a.986.986,0,0,1-.644.925c-1.432.53-2.75,1-3.864,1.461', 'M19.726,19.824a7.259,7.259,0,0,0,3.482-1.4,4.071,4.071,0,0,1-1.391-2.564', 'M22.251,23.245c-1.138-.476-2.5-.961-3.98-1.51']],
  HumanResourcesOfferWoman: ['human-resources-offer-woman', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.749 14.25L0.749 23.25', 'M.749,21.75h15a3,3,0,0,0-3-3H9a3,3,0,0,0-3-3H.749', 'M5.999 18.75L8.999 18.75', 'M18.261,12.077a7.262,7.262,0,0,0,4.988-1.339c-.75-.749-1.265-1.22-1.462-4.129C21.493,2.275,18.57.75,16.058.75s-5.435,1.525-5.729,5.859c-.2,2.909-.712,3.38-1.462,4.129a7.2,7.2,0,0,0,4.988,1.315', 'M21.609,14.727c-.837-.326-1.773-.664-2.772-1.033a.882.882,0,0,1-.576-.827V11.258a.881.881,0,0,1,.287-.651,3.171,3.171,0,0,0,1.035-2.366v-2.2a5.72,5.72,0,0,1-3.525-1.994,5.72,5.72,0,0,1-3.525,1.994v2.2a3.173,3.173,0,0,0,1.035,2.366.881.881,0,0,1,.287.651v1.609a.882.882,0,0,1-.576.827c-1.018.377-1.971.72-2.82,1.052']]
};
exports["default"] = _default;